import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clientoverviewrise() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return (
    <section className="client-overview-rise p-100">
      <Container>
        <div className="client-box-grey" style={{ background: "#F8F8F8" }}>
          <Row>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4 mb-md-0">
              <h2 style={{ color: "#111322" }}>Client Overview</h2>
              <p>
                Skylar Lewis, the visionary behind Rise Up Kings, created a
                platform as a hub for entrepreneurs and business enthusiasts.
                The app fosters networking, mentorship, and personal
                development, empowering users to achieve their entrepreneurial
                goals.
              </p>
              <div className="client-item">
                <h5 style={{ color: "#202020" }}>Industry</h5>
                <p>Entrepreneurship & Personal Development</p>
              </div>
              <div className="client-item">
                <h5 style={{ color: "#202020" }}>Business Type</h5>
                <p>Community-Driven Platform for Entrepreneurs</p>
              </div>
              <div className="client-item">
                <h5 style={{ color: "#202020" }}>Services Provided</h5>
                <p>
                  Mobile App Development (iOS & Android), Web Admin Panel, UI/UX
                  Design, Backend Architecture, Content Management,
                  Goal-Tracking Features, Event & User Management.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
              <div className="client-img">
                {videoLoaded ? (
                  <StaticImage
                    src="../../../images/case-studies/rise-up-king/client-overview-img-before.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={688}
                    height={904}
                  />
                ) : (
                  <StaticImage
                    src="../../../images/case-studies/rise-up-king/client-overview-img.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={2749}
                    height={3616}
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Clientoverviewrise;
